import JsonLd from "@/components/JsonLd.tsx";

type BreadcrumbItem = {
    name: string;
    item: string;
};

export default function JsonLdBreadcrumbList({
    routeId,
    crumbs = [],
}: {
    routeId: string;
    crumbs?: BreadcrumbItem[];
}) {
    return <JsonLd
        id={`page${routeId}/bc`}
        item={{
            "@context":        "https://schema.org",
            "@type":           "BreadcrumbList",
            "itemListElement": [
                {
                    "@type":    "ListItem",
                    "position": 1,
                    "name":     "Home",
                    "item":     "https://scorepal.co/"
                },
                ...crumbs.map(({ name, item }, i) => ({
                    "@type":    "ListItem",
                    "position": i + 2,
                    "name":     name,
                    "item":     item,
                }))
            ]
        }}
    />;
}
